import { ToolbarDropdownElement } from './ToolbarDropdownElement'

export class ToolbarFontSizeElement<T> extends ToolbarDropdownElement<T> {
  public iconElement: HTMLElement | undefined
  public override setFormat(format: { [key: string]: Set<any> }): void {
    super.setFormat(format)
    if (this.iconElement) {
      if (format[this.name] && format[this.name].size === 1) {
        const newValue = format[this.name].values().next().value
        if (newValue !== this.iconElement.innerText) {
          this.iconElement.innerText = newValue
        }
      } else {
        this.iconElement.innerText = ''
      }
    }
  }

  protected override initDom() {
    super.initDom()
    this.iconElement = this.entryElement.querySelector('.toolbar-dropdown-icon') as HTMLElement
    if (this.iconElement) {
      this.iconElement.innerText = '11'
      this.iconElement.classList.add('icon-font-size')
    }
  }
}
